"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const loglevel_1 = __importDefault(require("loglevel"));
const loglevel_plugin_prefix_1 = __importDefault(require("loglevel-plugin-prefix"));
loglevel_plugin_prefix_1.default.reg(loglevel_1.default);
loglevel_plugin_prefix_1.default.apply(loglevel_1.default, {
    template: "[%t] %l (%n):",
    levelFormatter(level) {
        return level.toUpperCase();
    },
    nameFormatter(name) {
        return name || "global";
    },
    timestampFormatter(date) {
        return date.toISOString();
    },
});
/**
 * Levels:
 *  - error: 0,
 *  - warn: 1,
 *  - info: 2,
 *  - debug: 3,
 *  - trace: 4
 */
class Logger {
    constructor(options) {
        this.options = options;
        const level = options.level || "warn";
        this.backend = loglevel_1.default.getLogger(options.label);
        this.backend.setLevel(level);
    }
    setLogLevel(logLevel) {
        this.backend.setLevel(logLevel);
    }
    async shutdown(gracePeriodMillis = 60000) {
        this.backend.info("Shut down logger OK.");
    }
    error(...msg) {
        this.backend.error(...msg);
    }
    warn(...msg) {
        this.backend.warn(...msg);
    }
    info(...msg) {
        this.backend.info(...msg);
    }
    debug(...msg) {
        this.backend.debug(...msg);
    }
    trace(...msg) {
        this.backend.trace(...msg);
    }
}
exports.Logger = Logger;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21haW4vdHlwZXNjcmlwdC9sb2dnaW5nL2xvZ2dlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSx3REFJa0I7QUFDbEIsb0ZBQTRDO0FBRTVDLGdDQUFNLENBQUMsR0FBRyxDQUFDLGtCQUFXLENBQUMsQ0FBQztBQUV4QixnQ0FBTSxDQUFDLEtBQUssQ0FBQyxrQkFBVyxFQUFFO0lBQ3hCLFFBQVEsRUFBRSxlQUFlO0lBQ3pCLGNBQWMsQ0FBQyxLQUFLO1FBQ2xCLE9BQU8sS0FBSyxDQUFDLFdBQVcsRUFBRSxDQUFDO0lBQzdCLENBQUM7SUFDRCxhQUFhLENBQUMsSUFBSTtRQUNoQixPQUFPLElBQUksSUFBSSxRQUFRLENBQUM7SUFDMUIsQ0FBQztJQUNELGtCQUFrQixDQUFDLElBQUk7UUFDckIsT0FBTyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUM7SUFDNUIsQ0FBQztDQUNGLENBQUMsQ0FBQztBQU9IOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLE1BQU07SUFHakIsWUFBNEIsT0FBdUI7UUFBdkIsWUFBTyxHQUFQLE9BQU8sQ0FBZ0I7UUFDakQsTUFBTSxLQUFLLEdBQWlCLE9BQU8sQ0FBQyxLQUFLLElBQUksTUFBTSxDQUFDO1FBQ3BELElBQUksQ0FBQyxPQUFPLEdBQUcsa0JBQVcsQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3BELElBQUksQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQy9CLENBQUM7SUFFTSxXQUFXLENBQUMsUUFBc0I7UUFDdkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDbEMsQ0FBQztJQUVNLEtBQUssQ0FBQyxRQUFRLENBQUMsb0JBQTRCLEtBQUs7UUFDckQsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsc0JBQXNCLENBQUMsQ0FBQztJQUM1QyxDQUFDO0lBRU0sS0FBSyxDQUFDLEdBQUcsR0FBVTtRQUN4QixJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxHQUFHLEdBQUcsQ0FBQyxDQUFDO0lBQzdCLENBQUM7SUFFTSxJQUFJLENBQUMsR0FBRyxHQUFVO1FBQ3ZCLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEdBQUcsR0FBRyxDQUFDLENBQUM7SUFDNUIsQ0FBQztJQUNNLElBQUksQ0FBQyxHQUFHLEdBQVU7UUFDdkIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsR0FBRyxHQUFHLENBQUMsQ0FBQztJQUM1QixDQUFDO0lBQ00sS0FBSyxDQUFDLEdBQUcsR0FBVTtRQUN4QixJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxHQUFHLEdBQUcsQ0FBQyxDQUFDO0lBQzdCLENBQUM7SUFDTSxLQUFLLENBQUMsR0FBRyxHQUFVO1FBQ3hCLElBQUksQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEdBQUcsR0FBRyxDQUFDLENBQUM7SUFDN0IsQ0FBQztDQUNGO0FBakNELHdCQWlDQyJ9